import vue from 'vue'
import elementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import less from 'less'

vue.use(elementUi);
vue.use(less);